import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';
import { RoverBrand } from '@rover/types/src/RoverBrand';

const SITE_NAME = {
  [RoverBrand.Rover]: 'Rover.com',
  [RoverBrand.CatInAFlat]: 'Cat in a Flat',
  [RoverBrand.MadPaws]: 'Mad Paws',
};

export default (): string =>
  getBrandSpecificValue({
    rover: SITE_NAME[RoverBrand.Rover],
    catInAFlat: SITE_NAME[RoverBrand.CatInAFlat],
    madPaws: SITE_NAME[RoverBrand.MadPaws],
  });
